import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetInstitution } from "../../../common/api/queries";
import BackNavigationArrow from "../../../common/components/views/BackNavigationArrow";
import ContentWrapper from "../../../common/modules/wrappers/ContentWrapper";
import DisplayWrapper from "../../../common/modules/wrappers/DisplayWrapper";
import { EntityIdObject } from "../../../common/types";
import { requests } from "../api";
import { InstitutionForm } from "../components/forms/InstitutionForm";

export const InstitutionDetailContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data } = useGetInstitution(id);

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={
          <BackNavigationArrow>
            <h2>{t("institution.titles.update")}</h2>
          </BackNavigationArrow>
        }
      >
        <DisplayWrapper itemLoaded={!!data} notFoundCheckRequest={requests.GET_INSTITUTION}>
          <InstitutionForm institution={data} />
        </DisplayWrapper>
      </Card>
    </ContentWrapper>
  );
};
